import {z} from 'zod'
import {AssetSchema} from './asset'
import {buildEntrySchemaFor} from '../entry'
import {PrimerCardsSchema} from './primerCards'
import {PrimerComponentAnchorNavSchema} from './primerComponentAnchorNav'
import {PrimerComponentFaqSchema} from './primerComponentFaq'
import {PrimerComponentHeroSchema} from './primerComponentHero'
import {PrimerComponentRiverSchema} from './primerComponentRiver'
import {PrimerComponentCtaBannerSchema} from './primerComponentCtaBanner'
import {PrimerComponentSectionIntroSchema} from './primerComponentSectionIntro'
import {PrimerTestimonialsSchema} from './primerTestimonials'
import {PrimerPillarsSchema} from './primerPillars'

export const TemplateFreeFormSectionSchema = buildEntrySchemaFor('templateFreeFormSection', {
  fields: z.object({
    id: z.string().optional(),
    components: z.array(
      z.union([
        PrimerComponentAnchorNavSchema,
        PrimerCardsSchema,
        PrimerComponentHeroSchema,
        PrimerComponentSectionIntroSchema,
        PrimerComponentRiverSchema,
        PrimerComponentFaqSchema,
        PrimerComponentCtaBannerSchema,
        PrimerPillarsSchema,
        PrimerTestimonialsSchema,
      ]),
    ),
    colorMode: z.enum(['inherit', 'light', 'dark']).default('inherit'),
    image: AssetSchema.optional(),
    imageMaxWidth: z.number().optional(),
  }),
})

export type TemplateFreeFormSection = z.infer<typeof TemplateFreeFormSectionSchema>
